export const MAP_ICON_SIZE = 63
export const MAP_ICON_PADDING = 6
export const MAP_ICON_BORDER_WIDTH = 5
export const MAP_HOVERED_ICON_SIZE = 1
export const MAP_NORMAL_ICON_SIZE = 0.71
export const MAP_DEFAULT_INDEX = 1
export const MAP_HOVERED_INDEX = 10